
import { useSelector } from "react-redux"

import { Routes, Route } from "react-router"

import { HomePage } from "../pages/comun/HomePage"

import { NotFoundPage } from "../pages/auth/NotFoundPage"

import { AdministracionPage } from "../pages/admin/AdministracionPage"
import { ApiKeysPage } from "../pages/admin/ApiKeysPage"
import { UsuariosPage } from "../pages/admin/UsuariosPage"

import { TipoUsuarioPage } from "../pages/catalogos/TipoUsuarioPage"
import { EstatusPage } from "../pages/catalogos/EstatusPage"
import { RootState } from "../store"
import { UnidadPage } from "../pages/catalogos/UnidadPage"
import { TipoCubiculoPage } from "../pages/catalogos/TipoCubiculoPage"
import { TipoSesionPage } from "../pages/catalogos/TipoSesionPage"

export const CubiculoRoutes = () => {

    const { administrador, token } = useSelector( ( state: RootState ) => state.auth );

    return (

        <Routes>

            {
                administrador
                ?
                    <>

                        <Route path="/" element={ <AdministracionPage /> } />   

                        <Route path="/gestionar-cubiculos" element={ <HomePage /> } />                           
                        
                        <Route path="/administracion/usuarios" element={ <UsuariosPage/> } />   
            
                        <Route path="/administracion/apikeys" element={ <ApiKeysPage/> } />    
            
                        <Route path="/administracion/apikeys" element={ <ApiKeysPage/> } />                
            
                        <Route path="/administracion/catalogos/estatus" element={ <EstatusPage/> } />  

                        <Route path="/administracion/catalogos/tipo-cubiculo" element={ <TipoCubiculoPage/> } /> 

                        <Route path="/administracion/catalogos/tipo-sesion" element={ <TipoSesionPage/> } /> 

                        <Route path="/administracion/catalogos/tipo-usuario" element={ <TipoUsuarioPage /> } />    

                        <Route path="/administracion/catalogos/unidad" element={ <UnidadPage/> } />   
                    
                    </>
                :
                    <Route path="/" element={ <HomePage /> } />   
            }    
            
            {
                token && <Route path="*" element={ <NotFoundPage /> } />
            }

        </Routes>        
    
    )
}